//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import dbmap from '@/assets/dbs/hashmap.js'
import VueQr from 'vue-qr'
import text from '@/assets/api/text.json'
export default {
    data () {
        return {
            config: {
                value: '',
            },
            productCode:"",
            textList:[],
            productCode:localStorage.getItem('productCode')
        }
    },
    mounted(){
        // process.env.BASE_URL
         text.map((item, index) => {
            if(this.productCode === item.code){
                this.textList = item;
                return
            }
            return
        });
        this.config.value = `${window.location.origin}/#/certified?loanOrderCode=${this.$route.query.loanOrderCode}`
        if(this.productCode == '6000'){
            let a = document.getElementById('qrUrl').getElementsByTagName("img")
            a[0].alt = this.config.value;
        }
    },
    methods:{
        btnBack(){
            this.$router.push("/index")
        },
        copyQrUrl(){
            let input = document.getElementById('textarea')
            input.value = this.config.value
            input.select()
            document.execCommand("Copy");
            document.getElementById('showTips').style.display = 'block'
            setTimeout(()=>{
                document.getElementById('showTips').style.display = 'none'
            },2000)
        }
    },
    components:{
        VueQr
    }
}




// WEBPACK FOOTER //
// ./src/view/acceptLoan.vue